/**
 * Devuelve el Id a auto-seleccionar en un catálogo: el marcado `IsDefault`,
 * o si ninguno lo está, el primero de la lista. Usar en un `useEffect` del
 * form con `setValue(field, getDefaultCatalogId(data))` cuando el campo
 * todavía no tiene valor — mismo criterio para Género/Nacionalidad/País
 * (Clientes) y Departamento/Categoría/Subcategoría/Tipo de producto/
 * Categoría de impuesto (Productos).
 */
export function getDefaultCatalogId<T extends { Id?: string; IsDefault?: boolean }>(
  items: T[] | undefined
): string | undefined {
  if (!items || items.length === 0) return undefined;
  return (items.find((i) => i.IsDefault) || items[0])?.Id;
}
